import { type ReactElement } from 'react';
import { type ColorlessIconProps, IconDocument, IconSlider, IconStack } from '@direct-frontend/components';
import { CONSTRUCTOR_FOOTER_ID, CONSTRUCTOR_HEADER_ID, CONSTRUCTOR_SLIDESHOW_ID } from './constants';

export const CONSTRUCTOR_SECTION_ICON_COMPONENT_MAP: Record<string, React.ComponentType<ColorlessIconProps>> = {
    default: IconDocument,
    [CONSTRUCTOR_SLIDESHOW_ID]: IconSlider,
    [CONSTRUCTOR_HEADER_ID]: IconStack,
    [CONSTRUCTOR_FOOTER_ID]: IconStack,
};

export const CONSTRUCTOR_SECTION_ICON_MAP_ACTIVE: Record<string, ReactElement> = {
    default: <IconDocument color="gray" />,
    [CONSTRUCTOR_SLIDESHOW_ID]: <IconSlider color="gray" />,
    [CONSTRUCTOR_HEADER_ID]: <IconStack color="gray" />,
    [CONSTRUCTOR_FOOTER_ID]: (
        <IconStack
            style={{
                transform: 'rotate(180deg)',
            }}
            color="gray"
        />
    ),
};

export const CONSTRUCTOR_SECTION_ICON_MAP_HIDDEN: Record<string, ReactElement> = {
    default: <IconDocument role="supplementary" color="gray" />,
    header: <IconStack role="supplementary" color="gray" />,
    footer: (
        <IconStack
            style={{
                transform: 'rotate(180deg)',
            }}
            role="supplementary"
            color="gray"
        />
    ),
};
